( function () {
    'use strict';
    var jHtml = jQuery( 'html' ),
        isTimeoutWebsite = jQuery('body').is('.timeout-website'),
        isCampletWebsite = jQuery('body').is('.camplet-website');
    jQuery.extend( true, e4.settings, {
        isTimeoutWebsite: isTimeoutWebsite,
        dealersearch:{
            url: jHtml.data( 'area' ) + '/system/data/dealersearch',
            map: {
                styles: isCampletWebsite ? [
                    {
                        "featureType": "all",
                        "elementType": "all",
                        "stylers": [
                            { "saturation": -100 }
                        ]
                    }
                ] : []
            }
        },
        ameasure:{
            url: jHtml.data( 'area' ) + '/system/data/a-measure-search'
        },
        villa:{
            acc: {
                url: jHtml.data( 'area' ) + '/system/data/villa-accessories'
            }
        },
        search: {
            result: {
                pages: {
                    url: jHtml.data( 'area' ) + '/system/data/pages?q='
                },
                products: {
                    show: !isTimeoutWebsite,
                    url: jHtml.data( 'area' ) + '/system/data/products?q=',
                    showAllLink: jHtml.data( 'area' ) + '/shop/search?q=',
                    max: {
                        xs: 2,
                        sm: 2,
                        md: 3,
                        lg: 3,
                        xl: 3
                    }
                }
            }
        },
        ecom: {
            filters: {
                url: jHtml.data( 'area' ) + '/system/data/products-with-filters'
            },
            cart: {
                url: jHtml.data( 'area' ) + '/system/data/cart'
            },
            download: {
                url: jHtml.data( 'area' ) + '/system/data/cart-download'
            },
            camplet: {
                url: jHtml.data( 'area' ) + '/system/data/cart-camplet'
            },
            quickorder: {
                url: jHtml.data( 'area' ) + '/system/data/quicksearch'
            },
            related:{
                url: jHtml.data( 'area' ) + '/system/data/related-products'
            },
            recommended: {
                url: jHtml.data( 'area' ) + '/system/data/products'
            },
            checkout: {
                url: jHtml.data( 'area' ) + '/system/data/checkout',
                termsAndConditions: jHtml.data( 'area' ) + (jHtml.data( 'area' ).toLowerCase().indexOf('webshop') > -1 ? '/shop' : '') + '/terms-and-conditions'
            }
        },
        require: {
            datepicker: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.js',
                fallback: '/files/templates/designs/isabella/_assets/js/vendor/bootstrap-datepicker.js',
                callback: null
            },
            pdfMake: {
                //url: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.33/pdfmake.js',
                url: '/files/templates/designs/isabella/_assets/js/vendor/pdfmake.js',
                fallback: '/files/templates/designs/isabella/_assets/js/vendor/pdfmake.js',
                callback: null
            },
            pdfFont: {
                //url: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.33/vfs_fonts.js',
                url: '/files/templates/designs/isabella/_assets/js/vendor/vfs_fonts.js',
                fallback: '/files/templates/designs/isabella/_assets/js/vendor/vfs_fonts.js',
                callback: null
            },
            pdfUtils: {
                url: '/files/templates/designs/isabella/_assets/_dist/js/pdf/pdf.utillities.js',
                fallback: '/files/templates/designs/isabella/_assets/_dist/js/pdf/pdf.utillities.js',
                callback: null
            },
            signBuilder: {
                url: '/files/templates/designs/isabella/_assets/_dist/js/pdf/pdf.signbuilder.js',
                fallback: '/files/templates/designs/isabella/_assets/_dist/js/pdf/pdf.signbuilder.js',
                callback: null
            },
            productDetailsPdf: {
                url: '/files/templates/designs/isabella/_assets/_dist/js/pdf/pdf.isabella.js',
                fallback: '/files/templates/designs/isabella/_assets/_dist/js/pdf/pdf.isabella.js',
                callback: null
            },
            villaAndCampletPdf: {
                url: '/files/templates/designs/isabella/_assets/_dist/js/pdf/pdf.villa-and-camplet.js',
                fallback: '/files/templates/designs/isabella/_assets/_dist/js/pdf/pdf.villa-and-camplet.js',
                callback: null
            },
            rwdImageMaps: {
                url: '/files/templates/designs/isabella/_assets/js/vendor/rwd-image-maps.js',
                fallback: '/files/templates/designs/isabella/_assets/js/vendor/rwd-image-maps.js',
                callback: null
            }
        }
    } );
}() );
